import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var chooseImage = normalize.chooseImage(function (args) {
  return isDingdingMiniapp ? dd.chooseImage(args) : my.chooseImage(args);
}, CONTAINER_NAME.ALIPAY);
export default chooseImage;